import { useGetEventSubmissionList, useGetEventCategories, useGetEventList } from '../../queries/event';
import { useGetAllUsers } from '../../queries/user';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";
import EventsListTable from './components/EventsListTable';
import EventSubmissionList from './components/EventSubmissionList';
import { useState, useEffect } from 'react';
import { ActionButton } from '../../components/Forms/ActionButton';

const EventSubmissions = () => {
    const { data, isPending } = useGetEventSubmissionList();
    const { data: categories } = useGetEventCategories();
    const { data: events } = useGetEventList();
    const { data: users } = useGetAllUsers(toast);

    const [filters, setFilters] = useState({
        search: '',
        category: '',
        event: '',
        user: '',
        status: '',
        fromDate: '',
        toDate: '',
    });
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        if (Array.isArray(data)) {
            setFilteredData(data);
        } else {
            setFilteredData([]);
        }
    }, [data]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleSearch = (e) => {
        e && e.preventDefault && e.preventDefault();
        let filtered = Array.isArray(data) ? data : [];
        if (filtered.length === 0) return;
        if (filters.search) {
            filtered = filtered.filter(item => item?.eventId?.title?.toLowerCase().includes(filters.search.toLowerCase()));
        }
        if (filters.category) {
            filtered = filtered.filter(item => {
                const catId = item?.eventId?.typeOfEvent;
                console.log(catId)
                return catId && catId.toString() === filters.category.toString();
            });
        }
        if (filters.event) {
            filtered = filtered.filter(item => item?.eventId?._id === filters.event);
        }
        if (filters.user) {
            filtered = filtered.filter(item => item?.userId?._id === filters.user);
        }
        if (filters.status) {
            filtered = filtered.filter(item => {
                // Match the status logic from renderChips
                if (item.reviewDate !== null) {
                    if (item.allocatedPoints > 0) {
                        return filters.status === 'accepted';
                    } else {
                        return filters.status === 'rejected';
                    }
                } else if (item.status === 'attended') {
                    return filters.status === 'attended';
                } else if (item.status === 'registered') {
                    return filters.status === 'registered';
                } else {
                    return false;
                }
            });
        }
        if (filters.fromDate) {
            filtered = filtered.filter(item => {
                const itemDate = item?.submissionDate ? new Date(item.submissionDate) : null;
                if (!itemDate) return false;
                // Compare only date part
                const itemDateStr = itemDate.toISOString().slice(0, 10);
                return itemDateStr >= filters.fromDate;
            });
        }
        if (filters.toDate) {
            filtered = filtered.filter(item => {
                const itemDate = item?.submissionDate ? new Date(item.submissionDate) : null;
                if (!itemDate) return false;
                // Compare only date part
                const itemDateStr = itemDate.toISOString().slice(0, 10);
                return itemDateStr <= filters.toDate;
            });
        }
        setFilteredData(filtered);
    };

    const handleReset = () => {
        setFilters({ search: '', category: '', event: '', user: '', status: '', fromDate: '', toDate: '' });
        setFilteredData(Array.isArray(data) ? data : []);
    };

    if (isPending) {
        return (
            <main className="flex flex-col text-base font-semibold text-gray-900 rounded-none">
                <section className="flex flex-col pt-5 w-full  bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                    <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                        <h1 className="self-start text-lg font-semibold">List of Events</h1>
                        <p>Loading...</p>
                    </div>
                </section>
            </main>
        )
    }

    return (
        <main className="flex flex-col text-base font-semibold text-gray-900 rounded-none">
            {/* Filters */}
            <form className="flex flex-col pt-5 w-full bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full" onSubmit={handleSearch}>
                <div className='flex items-center justify-between pr-5'>
                    <div className="flex gap-1.5 items-start my-auto text-base whitespace-nowrap ml-5">
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/4dd39feef0ff4934d9e2e86b8c7285d5d7532aeb26adcdc1e878d021439e2681?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                            alt=""
                            className="object-contain shrink-0 w-5 aspect-square"
                        />
                        <span className="self-stretch">Filters</span>
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/d18f51a0b2d597a302f55b77fc1071043eab5f274a1cc9e9b3fe3e2c97520a8c?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                            alt=""
                            className="object-contain shrink-0 aspect-square w-[18px]"
                        />
                    </div>
                </div>
                <div className="flex flex-wrap gap-4 p-5">
                    <div className='flex gap-3 w-full'>
                        {/* <div className="flex-col w-full">
                            <label htmlFor="search" className="gap-1 self-stretch w-full text-gray-900 text-base">Search</label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="text"
                                    name="search"
                                    value={filters.search}
                                    onChange={handleFilterChange}
                                    placeholder="Search by event title"
                                    className='outline-none focus:ring-0 w-full'
                                />
                            </div>
                        </div> */}
                        <div className="flex-col w-full">
                            <label htmlFor="category" className="gap-1 self-stretch w-full text-gray-900 text-base">Category</label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="category"
                                    value={filters.category}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base w-full"
                                >
                                    <option value="">All</option>
                                    {Array.isArray(categories) && categories.map((cat) => (
                                        <option key={cat._id} value={cat._id}>{cat.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="event" className="gap-1 self-stretch w-full text-gray-900 text-base">Event</label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="event"
                                    value={filters.event}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base w-full"
                                >
                                    <option value="">All</option>
                                    {Array.isArray(events) && events.map((ev) => (
                                        <option key={ev._id} value={ev._id}>{ev.title}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='flex gap-3 w-full'>
                        <div className="flex-col w-full">
                            <label htmlFor="user" className="gap-1 self-stretch w-full text-gray-900 text-base">Submitted By</label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="user"
                                    value={filters.user}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base w-full"
                                >
                                    <option value="">All</option>
                                    {Array.isArray(users) && users.map((user) => (
                                        <option key={user._id} value={user._id}>{user.username}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="status" className="gap-1 self-stretch w-full text-gray-900 text-base">Status</label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="status"
                                    value={filters.status}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base w-full"
                                >
                                    <option value="">All</option>
                                    <option value="registered">Registered</option>
                                    <option value="attended">Attended</option>
                                    <option value="accepted">Accepted</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="fromDate" className="gap-1 self-stretch w-full text-gray-900 text-base">From Submission Date</label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="date"
                                    name="fromDate"
                                    value={filters.fromDate}
                                    onChange={handleFilterChange}
                                />
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="toDate" className="gap-1 self-stretch w-full text-gray-900 text-base">To Submission Date</label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="date"
                                    name="toDate"
                                    value={filters.toDate}
                                    onChange={handleFilterChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='flex gap-3 items-center justify-end p-5'>
                    <ActionButton
                        variant={'reset'}
                        text={'Reset'}
                        handleSubmit={handleReset}
                    />
                    <ActionButton
                        variant={'submit'}
                        text={'Search'}
                        handleSubmit={handleSearch}
                    />
                </div>
            </form>
            <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                    <h1 className="self-start text-lg font-semibold">List of Submitted/Registered Events</h1>
                    <EventSubmissionList
                        data={filteredData}
                        toast={toast}
                    />
                </div>
            </section>
            <ToastContainer
                position="top-right"
                autoClose={3000}
            />
        </main>
    );
}

export default EventSubmissions;